document.addEventListener("DOMContentLoaded", function(){
    prodInfoAccordionFs();
});

function prodInfoAccordionFs() {
    const accordions = document.getElementsByClassName("pdp-info-accordion-fs");
    
    for (let i = 0; i < accordions.length; i++) {
        let panel = accordions[i].nextElementSibling;

        if (panel.classList.contains("to-open")) {
            panel.style.maxHeight = panel.scrollHeight + "px";
            panel.classList.remove("to-open");
        }

        accordions[i].addEventListener("click", function() {
            this.classList.toggle("to-open");
            
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }
}